import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42395930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "directives-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "v-model", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Mouse-X-Coordinate: ")
const _hoisted_4 = { style: {"font-weight":"bold"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "red" }, "Red", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "blue" }, "Blue", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "yellow" }, "Yellow", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "green" }, "Green", -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "testX" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("v-for, v-if, v-bind (aka "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"monospace","background-color":"#cccccc","padding":"0px 4px","border-radius":"3px"} }, ":"),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_12 = ["id", "value"]
const _hoisted_13 = ["for"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Checked names are:", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "v-on (aka \"@\")", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "v-html", -1))

import {ref} from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "0fa812e8": (color.value)
}))

const color = ref('red');
const message = "Welcome to Vue!";
const name = ref('');
const checkedNames = ref([]);
const options = [
        {
          value: 'Lisa',
          clicked: false
        },
        {
          value: 'Lutz',
          clicked: false
        },
        {
          value: 'Christopher',
          clicked: false
        },
        {
          value: 'Sita',
          clicked: false
        },
        {
          value: 'Anja',
          clicked: false
        },
        {
          value: 'Simon',
          clicked: false
        },
        {
          value: 'Robs',
          clicked: false
        },
        {
          value: 'Soubhi',
          clicked: false
        },
        {
          value: 'Mohammed',
          clicked: false
        },
      ];
const strikeClass = ref('strike');
const counter = ref(0);
const htmlString = '<a target="_blank" href="https://developer.mozilla.org/de/docs/Web/HTML" targe="_blank">v-html treats a parsed string as html</a>';
const x = ref(0);
const xCoordinate = (e: MouseEvent) => {
      return x.value = e.clientX;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(message)),
    _createElementVNode("div", {
      onMousemove: xCoordinate,
      style: _normalizeStyle({width: '80vw', backgroundColor: `hsl(${x.value}, 50%, 50%)`})
    }, [
      _hoisted_2,
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(x.value), 1)
      ])
    ], 36),
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
      rows: "5"
    }, null, 512), [
      [
        _vModelText,
        name.value,
        void 0,
        { trim: true }
      ]
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((color).value = $event))
      }, _hoisted_9, 512), [
        [_vModelSelect, color.value]
      ]),
      _createElementVNode("p", null, _toDisplayString(color.value), 1)
    ]),
    _createElementVNode("p", _hoisted_10, "Name: " + _toDisplayString(name.value), 1),
    _hoisted_11,
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
      return _createElementVNode("div", { key: option }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkedNames).value = $event)),
          id: option.value,
          value: option.value
        }, null, 8, _hoisted_12), [
          [_vModelCheckbox, checkedNames.value]
        ]),
        _createElementVNode("label", {
          for: option.value,
          class: _normalizeClass([checkedNames.value.includes(option.value) ? strikeClass.value : ''])
        }, _toDisplayString(option.value), 11, _hoisted_13),
        _hoisted_14
      ])
    }), 64)),
    _hoisted_15,
    (!checkedNames.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No boxes ticked! "))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(checkedNames.value, (name) => {
          return (_openBlock(), _createElementBlock("div", { key: name }, _toDisplayString(name), 1))
        }), 128)),
    _hoisted_17,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (counter.value > 0 ? counter.value -=1 : 0))
      }, "-"),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (counter.value+=1))
      }, "+"),
      _createElementVNode("span", null, _toDisplayString(counter.value), 1)
    ]),
    _hoisted_18,
    _createElementVNode("p", { innerHTML: htmlString })
  ]))
}
}

})